import { Component, OnInit } from '@angular/core';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { environment } from 'src/environments/environment';
import {Constants} from "../../../../core/models/common.models";
import {AdminService} from "../../../../core/services/admin-apis/admin.service";
import {PassportService} from "../../../passport/services/passport.service";
import {AuthenticationService} from "../../../../core/services/Authentication/authentication.service";

@Component({
  selector: 'app-upcoming-premiere',
  templateUrl: './upcoming-premiere.component.html',
  styleUrls: ['./upcoming-premiere.component.css'],
})
export class UpcomingPremiereComponent implements OnInit {
  premierelist: any;
  spotlightSchedule: any = [];
  upcomingEvent: any;
  userTime: any;
  agilePurchaseEnabled:boolean= environment.agilePurchaseEnabled;
  constructor(     private spotlightService: SpotlightService,
                   private adminApi: AdminService,
                   private readonly passportService: PassportService,
                   private authService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    // this.spotlightService.getData().subscribe(
      this.adminApi.SpotlightActiveListEvents().subscribe(
        data => {
          this.premierelist =data;
          for (let i = 0; i < this.premierelist.length; i++) {
            this.spotlightSchedule =
              this.premierelist[i].cinejoySpotlightsSchedule;
            if (this.spotlightSchedule && this.spotlightSchedule.length) {
              this.premierelist[i].cinejoySpotlightsSchedule = this.premierelist[i].cinejoySpotlightsSchedule.sort(
                (x: any, y: any) =>
                  +new Date(x.scheduleTimeText) - +new Date(y.scheduleTimeText)
              );
            }
          }
          // Filter the premierelist to only include events with cinejoySpotlightsSchedule and cinejoyFeaturedGuests
          this.premierelist = this.premierelist.filter(event =>
            event.cinejoySpotlightsSchedule.length > 0 &&
            event.cinejoyFeaturedGuests.length > 0 &&
            event.cinejoySpotlightsSchedule[event.cinejoySpotlightsSchedule.length - 1].scheduleTimeText > new Date().getTime()
          );

          this.spotlightService.setIsMotionGraphicsCompleted(false);
          this.premierelist.sort((x: any, y: any) => +new Date(x.cinejoySnotepotlightsSchedule[0].scheduleTimeText) - +new Date(y.cinejoySpotlightsSchedule[0].scheduleTimeText));
          this.premierelist = this.premierelist.slice(0, 4);
        });


    this.authService.checkUserAuthenticated().subscribe(
      (res) => {
        if (res.userId > 0){
          this.passportService.getData().then(profile => {
            localStorage.setItem(Constants.localStorageKeys.PASSPORT_PROFILE, JSON.stringify(profile));
          });
        }
      });

  }
}
